import { Swiper } from 'swiper';
import {Navigation, Autoplay, Pagination} from "swiper/modules";
Swiper.use([Navigation, Autoplay, Pagination]);

export default () => {
    const nodeSelectors = {
        container: '[js-services-gallery="container"]',
        slider: '[js-services-gallery="slider"]',
        prev: '[js-services-gallery="prev"]',
        next: '[js-services-gallery="next"]',
        pagination: '[js-services-gallery="pagination"]',
        
    }

    function init() {
        if (!document.querySelector(nodeSelectors.slider)) {
            return
        }

        initSlider()
    }

    function initSlider() {
        let slidersContainers = document.querySelectorAll(nodeSelectors.container)

        slidersContainers.forEach(function (container, index) {
            let sliderEl = container.querySelector(nodeSelectors.slider)

            let sliderServices = new Swiper(sliderEl, {
                loop: false,
                speed: 500,
                autoplay: {
                    delay: 2500
                },
                pagination: {
                    el: '.custom-swiper-pagination',
                },
                navigation: {
                    nextEl: '.custom-swiper-button-next',
                    prevEl: '.custom-swiper-button-prev',
                },
                breakpoints: {
                    300: {
                        slidesPerView: 1,
                    },
                    // when window width is >= 480px
                    768: {
                        slidesPerView: 2
                    },
                    // when window width is >= 640px
                    1024: {
                        slidesPerView: 4
                    }
                }
            });
        })
    }

    return Object.freeze({
        init,
    })
}